export default {
  app: {
    title: 'VIP Travellers',
    tagline: 'Yönetim Paneli',
  },
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    new: 'Yeni',
    back: 'Geri',
    yes: 'Evet',
    no: 'Hayır',
    loading: 'Yükleniyor…',
    search: 'Ara',
    actions: 'İşlemler',
    confirm: 'Onayla',
    confirmDelete: 'Silmek istediğinize emin misiniz?',
    none: 'Kayıt yok.',
    saved: 'Kaydedildi.',
    deleted: 'Silindi.',
    created: 'Oluşturuldu.',
    error: 'Bir hata oluştu.',
    required: 'Zorunlu alan',
    page: 'Sayfa',
    of: '/',
    total: 'toplam',
    upload: 'Yükle',
    select: 'Seç',
    clear: 'Temizle',
    optional: 'opsiyonel',
    enabled: 'Aktif',
    disabled: 'Pasif',
    published: 'Yayında',
    draft: 'Taslak',
    featured: 'Öne çıkan',
    order: 'Sıra',
    image: 'Görsel',
    gallery: 'Galeri',
  },
  auth: {
    loginTitle: 'Yönetim Paneline Giriş',
    loginSubtitle: 'VIP Travellers ekibi için ayrılmıştır.',
    email: 'E-posta',
    password: 'Şifre',
    signin: 'Giriş Yap',
    signinLoading: 'Giriş yapılıyor…',
    invalid: 'Geçersiz e-posta veya şifre.',
    signOut: 'Çıkış',
  },
  nav: {
    dashboard: 'Pano',
    content: 'İçerik',
    hotels: 'Oteller',
    villas: 'Villalar',
    rooms: 'Odalar',
    locations: 'Lokasyonlar',
    promotions: 'Kampanyalar',
    services: 'Servisler',
    blog: 'Blog',
    testimonials: 'Yorumlar',
    audience: 'Hedef Kitle',
    newsletter: 'Bülten',
    contact: 'İletişim Mesajları',
    library: 'Kütüphane',
    media: 'Medya',
    system: 'Sistem',
    settings: 'Ayarlar',
    users: 'Kullanıcılar',
  },
  dashboard: {
    welcome: 'Hoş geldin',
    summary: 'Özet',
    quickLinks: 'Hızlı Erişim',
  },
  hotels: {
    title: 'Oteller',
    newOne: 'Yeni Otel',
    listEmpty: 'Henüz otel eklenmemiş.',
    fields: {
      name: 'Otel Adı',
      slug: 'Slug',
      location: 'Lokasyon',
      address: 'Adres',
      phone: 'Telefon',
      email: 'E-posta',
      website: 'Resmi Site',
      hero: 'Kapak Görseli',
      gallery: 'Galeri',
      shortDescription: 'Kısa Açıklama',
      description: 'Açıklama',
      priceFrom: 'Başlangıç Fiyatı (EUR)',
      published: 'Yayınla',
      featured: 'Öne çıkar',
    },
  },
  villas: { title: 'Villalar', newOne: 'Yeni Villa' },
  locations: { title: 'Lokasyonlar', newOne: 'Yeni Lokasyon' },
  rooms: { title: 'Odalar', newOne: 'Yeni Oda' },
  promotions: { title: 'Kampanyalar', newOne: 'Yeni Kampanya' },
  services: { title: 'Servisler', newOne: 'Yeni Servis' },
  blog: { title: 'Blog', newOne: 'Yeni Yazı' },
  testimonials: { title: 'Yorumlar', newOne: 'Yeni Yorum' },
  newsletter: { title: 'Bülten Aboneleri', exportCsv: 'CSV İndir' },
  contact: { title: 'İletişim Mesajları', markRead: 'Okundu işaretle' },
  media: {
    title: 'Medya Kütüphanesi',
    upload: 'Yeni Yükle',
    altText: 'Alt Metin',
    caption: 'Açıklama',
    pickerTitle: 'Görsel Seç',
  },
  settings: {
    title: 'Site Ayarları',
    tabs: {
      brand: 'Marka',
      contact: 'İletişim',
      social: 'Sosyal',
      homepage: 'Anasayfa',
      seo: 'SEO',
      pages: 'Sayfalar',
    },
    brand: {
      logoUrl: 'Logo URL',
      logoAlt: 'Logo alt metni',
      name: 'Marka adı',
    },
    contact: {
      phone: 'Telefon',
      whatsapp: 'WhatsApp',
      email: 'E-posta',
      address: 'Adres',
      workingHoursEn: 'Çalışma saatleri (EN)',
      workingHoursRu: 'Çalışma saatleri (RU)',
    },
    homepage: {
      hero: 'Hero',
      welcome: 'Welcome bloku',
      testimonialBg: 'Testimonial arka planı',
    },
    pages: {
      about: 'Hakkımızda',
      wellness: 'Wellness & Spa',
      ourServices: 'Hizmetlerimiz',
      heroImage: 'Kapak görseli',
      body: 'İçerik',
    },
  },
  users: { title: 'Kullanıcılar', newOne: 'Yeni Kullanıcı' },
};
